export const ToolIcon = ({ className }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.9987 6.43461C4.59899 5.71126 4.43315 4.88187 4.52396 4.06044C4.61478 3.23902 4.9578 2.46588 5.50586 1.84732C6.05393 1.22877 6.78013 0.795149 7.58464 0.606083C8.38916 0.417017 9.23249 0.481784 9.9987 0.79148L7.4987 3.50085L7.85245 5.1471L9.4987 5.50085L12.2081 3.00085C12.5178 3.76706 12.5825 4.61039 12.3935 5.41491C12.2044 6.21942 11.7708 6.94562 11.1522 7.49369C10.5337 8.04175 9.76053 8.38477 8.93911 8.47559C8.11768 8.5664 7.28829 8.40056 6.56495 8.00085L3.0612 12.0634C2.7794 12.3451 2.39721 12.5035 1.9987 12.5035C1.60018 12.5035 1.21799 12.3451 0.936196 12.0634C0.654403 11.7816 0.496094 11.3994 0.496094 11.0009C0.496094 10.6023 0.654403 10.2201 0.936196 9.93836L4.9987 6.43461Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
